import * as t from 'ts-schema';

/**
 * Parse an unknown value into a type, using JSON.parse and ts-schema validation. The parsed value is guaranteed to match the outputted type.
 *
 * @throws {Error} if parsing fails or if the value does not match the schema
 */
export const parse = function parse(value, schema) {
  const parsedValue = value ? JSON.parse(value) : undefined;
  t.assert(schema, parsedValue);
  return parsedValue;
};

/**
 * Curry the parse function to create a function that parses a value into a type.
 *
 * Mostly useful for creating reusable parsers for common types.
 *
 * @throws {Error} if parsing fails or if the value does not match the schema
 */
export const parseCurried = schema => value => parse(value, schema);